<template>
  <v-container>
    <v-row align="center" justify="center">
      <v-col cols="4">
        <v-menu
          ref="menu1"
          v-model="menu1"
          offset-y
          max-width="290px"
          min-width="290px"
          :close-on-content-click="false"
          transition="scale-transition"
        >
          <template v-slot:activator="{ on, attrs }">
            <v-text-field
              v-model="anchorDate"
              readonly
              v-bind="attrs"
              v-on="on"
              label="Select Date"
              prepend-icon="mdi-calendar"
            ></v-text-field>
          </template>
          <v-date-picker v-model="anchorDate"></v-date-picker>
        </v-menu>
      </v-col>
    </v-row>

    <v-data-table
      :headers="headers"
      :items="results"
      :items-per-page="60"
      dense
      :loading="loading"
      class="mt-2 elevation-2"
    >
      <template v-slot:item.dropoffPercent="{ item }">
        <span> {{ item.dropoffPercent }}% </span>
      </template>
    </v-data-table>
  </v-container>
</template>

<script>
import { CAPACITY_PLANNING_QUERY } from "@/graphql/queries/coaching";
export default {
  name: "CapacityPlanning",
  components: {},
  data() {
    return {
      loading: false,
      anchorDate: null,
      menu1: false,
      results: [],
      headers: [
        { text: "Coach", value: "coach" },
        { text: "Clients not yet started", value: "notStarted" },
        { text: "New clients in last 30 days", value: "new" },
        { text: "Recurring clients, not ending 30 days", value: "recurring" },
        { text: "Clients ending in next 30 days", value: "ending" },
        { text: "Current client balance", value: "balance" },
        { text: "30 day forecast client balance", value: "forecastBalance" },
        { text: "Forecast net change", value: "forecastChange" },
        { text: "% Drop-off", value: "dropoffPercent" },
      ],
    };
  },
  apollo: {
    capacityPlanning: {
      query: CAPACITY_PLANNING_QUERY,
      fetchPolicy: "network-only",
      variables() {
        return {
          anchorDate: this.anchorDate,
        };
      },
      skip() {
        return !this.anchorDate;
      },
      result(response) {
        if (response.data) {
          this.results = response.data.capacityPlanning;
        }
      },
    },
  },
};
</script>
